// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--color: blue}", "",{"version":3,"sources":["webpack://src/theme/_default.scss"],"names":[],"mappings":"AAAA,MACE,aAAA","sourcesContent":[":root {\n  --color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
